<template>
    <div class="feedback-button" @click="openEmail">
      <span class="label">Feedback</span>
    </div>
  </template>
  
  <script>
  export default {
    methods: {
      openEmail() {
        window.location.href = "mailto:tyrese.makhubele@gmail.com";
      }
    }
  }
  </script>
  
  <style scoped>
  .feedback-button {
    position: fixed;
    right: -10px; /* Adjust the positioning */
    bottom: 20%; /* Position it in the middle of the page */
    background-color: blueviolet;
    color: white;
    padding: 5px 10px 15px 10px;
    border-radius: 5px;
    display: flex;
    align-items: center;
    cursor: pointer;
    transform: rotate(-90deg); /* Rotate the button 90 degrees */
    transform-origin: bottom right; /* Set the rotation origin */
    z-index: 9999;
    border: 1px dotted white;
  }
  
  .icon {
    width: 24px;
    height: 24px;
    margin-right: 5px;
    transform: rotate(90deg); /* Rotate the icon back to its original orientation */
  }
  
  .label {
    font-size: 13px;
  }
  </style>
  